/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.BasicSearch";
        class BasicSearchWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("BasicSearchWidgetTypeClass.createInstance()");
                    return new BasicSearchWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("BasicSearchWidgetTypeClass._storeHtml()");
                    BasicSearchWidgetInstanceClass.HtmlData = htmlData;
                    this._presentInstances();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("BasicSearchWidgetTypeClass::constructor");
                if (BasicSearchWidgetInstanceClass.HtmlData != null) {
                    // make async call in order to get the instances created first
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    core.Loader.getVersionedHTML('widgets/BasicSearch/basic-search.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
            }
        }
        Widgets.BasicSearchWidgetTypeClass = BasicSearchWidgetTypeClass;
        class BasicSearchWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._loader = null;
                this._noRecords = null;
                this._moreRecords = null;
                this._holder = null;
                this._dataList = null;
                this._filterText = null;
                this._showFilterIcon = null;
                this._hideFilterIcon = null;
                this._filter = null;
                this._registerDeselection = false;
                this._activateAsPrimary = true;
                this._activateAsRelated = false;
                this._activateIntoSlot = null;
                this._autoSelectMode = Widgets.DocumentAutoSelectMode.NONE;
                this._autoSelectOnHomeView = false;
                this._registerEmptyQueries = false;
                this._reactToSlots = [];
                this._lastReactedSlots = [];
                this._reselectOnRefresh = true;
                this._relatedMode = false;
                this._clearOnDeselect = true;
                this._reactToDocTypes = [];
                this._documents = null;
                this._requestQueueInfo = false;
                this._lastSelectedDocument = null;
                this._refreshTriggers = null;
                this.presentInstance = () => {
                    this._log.info("BasicSearchWidgetInstanceClass.presentInstance()");
                    this._container.innerHTML = BasicSearchWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    this._loader = this._container.querySelector('.wpt-hourglass');
                    this._noRecords = this._container.querySelector('#basicSearchNoRecords');
                    this._moreRecords = this._container.querySelector('#basicSearchMoreRecords');
                    this._holder = this._container.querySelector('#basicSearchHolder');
                    this._filterText = this._container.querySelector('#basicSearchFilter');
                    this._showFilterIcon = this._container.querySelector('.basicSearchShowFilter');
                    this._hideFilterIcon = this._container.querySelector('.basicSearchCancelFilter');
                    this._filter = this._container.querySelector('.widget__filter');
                    this._core.Helper.prepareHourglassIcon(this._loader);
                    this._widgets.setTitle(this._config, this._container.querySelector('#basicSearchWidgetTitle'), 'STR_WPT_SEARCH');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._container);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    this._core.Helper.setElementTranslation(this._container.querySelector('#basicSearchLoading'), 'STR_WPT_LOADING');
                    this._core.Helper.setElementTranslation(this._container.querySelector('#basicSearchNoRecordsMessage'), 'STR_WPT_NOINFO');
                    this._core.Helper.setElementTranslation(this._container.querySelector('#basicSearchMoreRecordsMessage'), 'STR_WPT_MORERECORDS');
                    this._core.Helper.setElementTranslationAttribute(this._filterText, 'placeholder', 'STR_WPT_FILTERLIST');
                    this._core.Helper.setElementTranslationAttribute(this._filterText, 'aria-label', 'STR_WPT_FILTERLIST');
                    this._core.Helper.setElementTranslationAttribute(this._showFilterIcon, 'title', 'STR_WPT_FILTER');
                    this._core.Helper.setElementTranslationAttribute(this._hideFilterIcon, 'title', 'STR_WPT_HIDE_FILTER');
                    this._core.Helper.setElementTranslationAttribute(this._container.querySelector('#basicSearchReload'), 'title', 'STR_WPT_REFRESH');
                    this._filterText.addEventListener('keyup', this._doFilter);
                    this._showFilterIcon.addEventListener('click', this._showFilter);
                    this._hideFilterIcon.addEventListener('click', this._hideFilter);
                    this._container.querySelector('#basicSearchReload').addEventListener('click', this._doSearch);
                    this._container.querySelector('#basicSearchNoRecordsReload').addEventListener('click', this._doSearch);
                    this._container.querySelector('#hideBasicSearchMoreRecordsMessage').addEventListener('click', this._hideMessage);
                    this._container.querySelector('.basicSearchClearFilter').addEventListener('click', this._clearFilter);
                    let listConfig = {
                        SelectItemCallback: this._docClicked
                    };
                    this._dataList = new Widgets.ComponentDataList(this._core, this._holder, this, listConfig);
                    this._dataList.present();
                    if (!this._relatedMode)
                        this._doSearch();
                    this._type.instanceReady(this.getHandle());
                };
                this._callFailedHandler = (json) => {
                    this._log.info("BasicSearchWidgetInstanceClass._callFailedHandler()");
                    let response = json;
                    this.addError(response.Connection.Message);
                    this._core.Functions.hideElement(this._loader);
                };
                this._callErrorHandler = (url, status, message) => {
                    this._log.info("BasicSearchWidgetInstanceClass._callErrorHandler()");
                    this.addError(message);
                    this._core.Functions.hideElement(this._loader);
                };
                this._doSearch = () => {
                    this._log.info("BasicSearchWidgetInstanceClass._doSearch()");
                    let config = this._config;
                    if (config.hasOwnProperty('Query')) {
                        this.updateSearch(config.Query);
                    }
                    else if (config.hasOwnProperty('FlexQuery')) {
                        this.updateSearchWithFlex(config.FlexQuery);
                    }
                    else {
                        console.warn("no 'Query/FlexQuery' configured for BasicSearch widget");
                        this._displayResult({});
                    }
                };
                this.updateSearch = (query) => {
                    this._log.info("BasicSearchWidgetInstanceClass.updateSearch()");
                    this._clearErrors();
                    this._core.Functions.showElement(this._loader);
                    let requestSearch = this._core.OBHelper.compileFlexSearchFromQueryDef(query);
                    requestSearch.ReturnQueues = this._requestQueueInfo;
                    this._core.Loader.genericServiceCallWithData('/Documents.svc/rest/DocumentQuery', JSON.stringify(requestSearch), this._displayResult, {}, this._callErrorHandler, this._callFailedHandler);
                };
                this.updateSearchWithFlex = (searchDef) => {
                    this._log.info("BasicSearchWidgetInstanceClass.updateSearchWithFlex()");
                    this._core.Functions.showElement(this._loader);
                    let requestSearch = this._core.OBHelper.flexDefinitionToRequest(searchDef);
                    requestSearch.ReturnQueues = this._requestQueueInfo;
                    this._core.Loader.genericServiceCallWithData('/Documents.svc/rest/DocumentQuery', JSON.stringify(requestSearch), this._displayResult, {}, this._callErrorHandler, this._callFailedHandler);
                };
                this._displayResult = (response) => {
                    this._log.info("BasicSearchWidgetInstanceClass._displayResult()");
                    this._core.Functions.hideElement(this._loader);
                    let firstDocId = null;
                    let previousDocId = null;
                    let previousDocStillAvailable = false;
                    let documentsLength = 0;
                    this._documents = [];
                    this._dataList.clearList();
                    if (response.hasOwnProperty('Documents') && response.Documents.length > 0) {
                        this._documents = response.Documents;
                        documentsLength = response.Documents.length;
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got documents: " + documentsLength);
                        }
                        this._core.Functions.hideElement(this._noRecords);
                        this._core.Functions.showElement(this._holder);
                        if (response.hasOwnProperty('HasMoreRecords') && response.HasMoreRecords) {
                            this._core.Functions.showElement(this._moreRecords);
                        }
                        else {
                            this._core.Functions.hideElement(this._moreRecords);
                        }
                        let listData = {
                            Items: []
                        };
                        for (let i = 0; i < documentsLength; i++) {
                            let doc = response.Documents[i];
                            let itemData = {
                                Id: doc.ItemNum.toString(10),
                                DisplayName: doc.Name
                            };
                            listData.Items.push(itemData);
                            if (!firstDocId)
                                firstDocId = itemData.Id;
                            if ((this._lastSelectedDocument != null) && (doc.ItemNum == this._lastSelectedDocument.ItemNum)) {
                                previousDocStillAvailable = true;
                                previousDocId = itemData.Id;
                            }
                        }
                        this._dataList.displayData(listData);
                    }
                    else {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got NO documents");
                        }
                        this._core.Functions.hideElement(this._moreRecords);
                        this._core.Functions.hideElement(this._holder);
                        this._core.Functions.showElement(this._noRecords);
                        this._emptyQueryReceived();
                    }
                    this._doFilter();
                    if (!previousDocStillAvailable) {
                        // If the previous document is no longer in the list, tell someone
                        if (this._lastSelectedDocument != null)
                            this._docDeselected();
                        this._lastSelectedDocument = null;
                        // If we are set to auto-select, fire that event
                        if (firstDocId) {
                            if ((this._autoSelectMode == Widgets.DocumentAutoSelectMode.FIRST) || ((this._autoSelectMode == Widgets.DocumentAutoSelectMode.SINGLE) && (documentsLength == 1))) {
                                if ((this._currentLayout != WPTNamespace.Navigation.HOME_VIEW_NAME) || this._autoSelectOnHomeView) {
                                    this._docClicked(firstDocId);
                                }
                            }
                        }
                        else
                            this._core.Widgets.setWidgetCollapseStateDirect(this, true);
                    }
                    else {
                        if ((this._lastSelectedDocument != null) && this._reselectOnRefresh) {
                            this._docClicked(previousDocId);
                        }
                    }
                };
                this._showFilter = () => {
                    this._log.info("BasicSearchWidgetInstanceClass._showFilter()");
                    this._core.Functions.hideElement(this._showFilterIcon);
                    this._core.Functions.showElement(this._hideFilterIcon);
                    this._core.Functions.showElement(this._filter);
                    this._filterText.focus();
                };
                this._hideFilter = () => {
                    this._log.info("BasicSearchWidgetInstanceClass._hideFilter()");
                    this._core.Functions.hideElement(this._hideFilterIcon);
                    this._core.Functions.showElement(this._showFilterIcon);
                    this._core.Functions.hideElement(this._filter);
                    this._clearFilter();
                };
                this._clearFilter = () => {
                    this._log.info("BasicSearchWidgetInstanceClass._clearFilter()");
                    this._core.Functions.clearAndFocusInputElement(this._filterText);
                    this._doFilter();
                };
                this._hideMessage = () => {
                    this._log.info("BasicSearchWidgetInstanceClass._hideMessage()");
                    this._core.Functions.hideElement(this._moreRecords);
                };
                this._doFilter = () => {
                    this._log.info("BasicSearchWidgetInstanceClass._doFilter()");
                    let filterText = this._filterText.value;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("filtering with: " + filterText);
                    }
                    this._dataList.filterItems(filterText);
                };
                this._docClicked = (itemNum) => {
                    this._log.info("BasicSearchWidgetInstanceClass._docClicked()");
                    // May need to loop back to self if queues not ready
                    if (this._requestQueueInfo && !this._core.OBHelper.QueuesLoaded) {
                        this._core.OBHelper.LoadQueues(this._docClicked.bind(this, itemNum));
                        return;
                    }
                    let config = this._config;
                    let docId = Number(itemNum);
                    this._lastSelectedDocument = this._documents.find(doc => doc.ItemNum == docId);
                    this._dataList.clearItemSelection();
                    this._dataList.selectItem(itemNum);
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_SELECTED);
                    navEvent.ActivationID = docId;
                    navEvent.PrimaryContext = this._lastSelectedDocument;
                    if (this._activateAsPrimary)
                        navEvent.Slots.push(WPTNamespace.Utilities.PRIMARY_SLOT_KEY);
                    if (this._activateAsRelated)
                        navEvent.Slots.push(WPTNamespace.Utilities.RELATED_SLOT_KEY);
                    if (this._activateIntoSlot)
                        navEvent.Slots.push(this._activateIntoSlot);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`Activating into slots ${navEvent.Slots}`);
                    }
                    if (this._requestQueueInfo) {
                        if (this._lastSelectedDocument.hasOwnProperty('Queues') && (this._lastSelectedDocument.Queues != null) && (this._lastSelectedDocument.Queues.length > 0)) {
                            let qId = this._lastSelectedDocument.Queues[0].Id;
                            navEvent.AdditionalContext["SourceQueueID"] = qId;
                            navEvent.AdditionalContext["SourceQueueRecord"] = this._core.OBHelper.Queues.find(q => q.Id == qId);
                        }
                    }
                    // Set default layout, but check if we've had an alternative requested against the instance
                    let targetLayoutName = "DocumentView";
                    if (config.hasOwnProperty("LaunchLayout") && config.LaunchLayout) {
                        if (config.LaunchLayout == "[[CURRENT]]")
                            targetLayoutName = this._currentLayout;
                        else
                            targetLayoutName = config.LaunchLayout;
                    }
                    // Add transfer widgets if we are moving
                    if (targetLayoutName != this._currentLayout) {
                        if (config.hasOwnProperty("ForwardOtherWidgets")) {
                            navEvent.populateTransferList(config.ForwardOtherWidgets, this._core);
                        }
                    }
                    navEvent.Layout = targetLayoutName;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._docDeselected = () => {
                    this._log.info("BasicSearchWidgetInstanceClass._docDeselected()");
                    // No such thing as a deselect related call, and we might have a LOT of related docs this is as it should be
                    if (!this._registerDeselection)
                        return;
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_DESELECTED);
                    navEvent.ActivationID = this._lastSelectedDocument.ItemNum;
                    navEvent.PrimaryContext = this._lastSelectedDocument;
                    if (this._activateAsPrimary)
                        navEvent.Slots.push(WPTNamespace.Utilities.PRIMARY_SLOT_KEY);
                    if (this._activateAsRelated)
                        navEvent.Slots.push(WPTNamespace.Utilities.RELATED_SLOT_KEY);
                    if (this._activateIntoSlot)
                        navEvent.Slots.push(this._activateIntoSlot);
                    navEvent.Layout = this._currentLayout;
                    this._core.Navigation.Details.requestActivation(navEvent);
                    this._lastSelectedDocument = null;
                };
                this._emptyQueryReceived = () => {
                    this._log.info("BasicSearchWidgetInstanceClass._emptyQueryReceived()");
                    if (!this._registerEmptyQueries)
                        return;
                    let config = this._config;
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.QUERY_NO_DOCUMENTS);
                    navEvent.ActivationID = 0;
                    navEvent.PrimaryContext = null;
                    // Set default layout, but check if we've had an alternative requested against the instance
                    let targetLayoutName = this._currentLayout;
                    if (config.hasOwnProperty("LaunchLayout") && config.LaunchLayout) {
                        if (config.LaunchLayout == "[[CURRENT]]")
                            targetLayoutName = this._currentLayout;
                        else
                            targetLayoutName = config.LaunchLayout;
                    }
                    // Add transfer widgets if we are moving
                    if (targetLayoutName != this._currentLayout) {
                        if (config.hasOwnProperty("ForwardOtherWidgets")) {
                            navEvent.populateTransferList(config.ForwardOtherWidgets, this._core);
                        }
                    }
                    navEvent.Layout = targetLayoutName;
                    this._core.Navigation.Details.requestActivation(navEvent);
                    this._lastSelectedDocument = null;
                };
                this.returnedToHomepage = () => {
                    this._log.info("BasicSearchWidgetInstanceClass.returnedToHomepage()");
                    super.returnedToHomepage();
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                };
                this._drivingDocSelected = (doc) => {
                    this._log.info("BasicSearchWidgetInstanceClass._drivingDocSelected()");
                    if (!doc && this._clearOnDeselect) {
                        // CLEAR STUFF DOWN
                        this._dataList.clearList();
                        this._core.Functions.hideElement(this._moreRecords);
                        this._core.Functions.showElement(this._noRecords);
                        this._lastSelectedDocument = null;
                        this._lastReactedSlots = [];
                        this._documents = [];
                    }
                    if ((this._reactToDocTypes.indexOf("*") > -1) || (this._reactToDocTypes.indexOf(doc.DocType.Name) > -1)) {
                        this._doSearch();
                    }
                };
                this._handleInHitList = (handle) => {
                    if (!this._documents || (this._documents.length == 0))
                        return false;
                    let doc = this._documents.find(d => (d.ItemNum == handle));
                    if (doc)
                        return true;
                    else
                        return false;
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("BasicSearchWidgetInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
                let conf = this._config;
                if (conf.hasOwnProperty("RegisterDeselection") && (conf.RegisterDeselection))
                    this._registerDeselection = true;
                if (conf.hasOwnProperty("ActivateAsPrimary") && (conf.ActivateAsPrimary != null))
                    this._activateAsPrimary = conf.ActivateAsPrimary;
                if (conf.hasOwnProperty("ActivateAsRelated") && (conf.ActivateAsRelated != null))
                    this._activateAsRelated = conf.ActivateAsRelated;
                if (conf.hasOwnProperty("ActivateIntoSlot") && (conf.ActivateIntoSlot != null))
                    this._activateIntoSlot = conf.ActivateIntoSlot;
                if (conf.hasOwnProperty('AutoSelectMode'))
                    this._autoSelectMode = Widgets.DocumentAutoSelectMode[conf.AutoSelectMode];
                if (conf.hasOwnProperty('AutoSelectOnHomeView') && conf.AutoSelectOnHomeView)
                    this._autoSelectOnHomeView = true;
                if (conf.hasOwnProperty("RegisterEmptyQueries") && (conf.RegisterEmptyQueries))
                    this._registerEmptyQueries = true;
                if (conf.hasOwnProperty("RegisterDeselection") && (conf.RegisterDeselection != null))
                    this._registerDeselection = conf.RegisterDeselection;
                if (conf.hasOwnProperty('ReselectOnRefresh') && (conf.ReselectOnRefresh != null))
                    this._reselectOnRefresh = conf.ReselectOnRefresh;
                if (conf.hasOwnProperty('RequestQueueInfo') && (conf.RequestQueueInfo != null))
                    this._requestQueueInfo = conf.RequestQueueInfo;
                if (conf.hasOwnProperty("ReactToSlots") && (conf.ReactToSlots != null))
                    this._reactToSlots = conf.ReactToSlots;
                else
                    this._reactToSlots = [];
                if (conf.hasOwnProperty("ReactToPrimary") && (conf.ReactToPrimary) && (this._reactToSlots.indexOf(WPTNamespace.Utilities.PRIMARY_SLOT_KEY) == -1))
                    this._reactToSlots.push(WPTNamespace.Utilities.PRIMARY_SLOT_KEY);
                if (conf.hasOwnProperty("ReactToRelated") && (conf.ReactToRelated) && (this._reactToSlots.indexOf(WPTNamespace.Utilities.RELATED_SLOT_KEY) == -1))
                    this._reactToSlots.push(WPTNamespace.Utilities.RELATED_SLOT_KEY);
                if (conf.hasOwnProperty("ReactToDocTypes") && (conf.ReactToDocTypes != null))
                    this._reactToDocTypes = conf.ReactToDocTypes;
                else
                    this._reactToDocTypes = ["*"];
                if (conf.hasOwnProperty("ClearOnDeselect") && (conf.ClearOnDeselect != null))
                    this._clearOnDeselect = conf.ClearOnDeselect;
                if (config.hasOwnProperty('RefreshTriggers') && conf.RefreshTriggers && (conf.RefreshTriggers.length > 0))
                    this._refreshTriggers = conf.RefreshTriggers;
                else
                    this._refreshTriggers = [];
                this._core.Functions.addDefaultsToTriggerEvents(this._refreshTriggers);
                if (this._requestQueueInfo)
                    this._core.OBHelper.LoadQueues();
                // Set related mode processing.
                this._relatedMode = (this._reactToSlots.length > 0);
            }
            activate(context) {
                this._log.info("BasicSearchWidgetInstanceClass.activate()");
                // Don't get stuck in a loop!
                if (!this._activationSourceValid(context))
                    return;
                switch (context.ActivationType) {
                    case WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_SELECTED:
                        if (this._relatedMode) {
                            let slots = this._reactToSlots.filter(slot => (context.Slots.indexOf(slot) > -1));
                            if (slots.length > 0) {
                                // only remember slots we react to
                                this._lastReactedSlots = slots;
                                this._drivingDocSelected(context.PrimaryContext);
                            }
                        }
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_DESELECTED:
                        if (this._relatedMode) {
                            let intersection = this._lastReactedSlots.filter(slot => (context.Slots.indexOf(slot) > -1));
                            if (intersection.length > 0) {
                                this._lastReactedSlots = [];
                                this._drivingDocSelected(null);
                            }
                        }
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_DELETED:
                        if (this._handleInHitList(context.ActivationID))
                            this._doSearch();
                        break;
                    default:
                        if (this._refreshTriggers.length > 0) {
                            // Loop with iterator so we can escape when necessary
                            for (let i = 0; i < this._refreshTriggers.length; i++) {
                                let trigger = this._refreshTriggers[i];
                                if (this._core.Functions.triggerEventMatches(trigger, context)) {
                                    this._doSearch();
                                    // Only trigger once
                                    return;
                                }
                                else {
                                    continue;
                                }
                            }
                        }
                        break;
                }
            }
        }
        BasicSearchWidgetInstanceClass.HtmlData = null;
        Widgets.BasicSearchWidgetInstanceClass = BasicSearchWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
